import React, { lazy, Suspense } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Login from './componentes/login/Login';
import MantenimientoEntidad from './componentes/entidad/MantenimientoEntidad';
import RutaProtegida from './miscelaneo/RutaProtegida';
import RutaNoEncontrada from './miscelaneo/RutaNoEncontrada';
import Estructura from './componentes/estructura/Layout';
import MantenimientoProducto from './componentes/inventario/MantenimientoProducto';
import MantenimientoAlmacen from './componentes/inventario/MantenimientoAlmacen';
import Dashboard from './componentes/dashboard/Dashboard';
import ProcesoTransferencia from './componentes/inventario/ProcesoTransferencia';
import ProcesoAjuste from './componentes/inventario/ProcesoAjuste';
import MantenimientoCategoria from './componentes/otros/MantenimientoCategoria';
import MantenimientoListaPrecio from './componentes/otros/MantenimientoListaPrecio';
import ProcesoCostosGastos from './componentes/otros/ProcesoCostosGastos';
import MantenimientoSecuenciaComprobante from './componentes/configuracion/MantenimientoSecuenciaComprobante';
import ValoresPorDefecto from './componentes/configuracion/ValoresPorDefecto';
import PantallaPasarelasPago from './componentes/configuracion/PantallaPasarelasPago';
import MantenimientoCuentaTributaria from './componentes/banco/MantenimientoCuentaTesoreria';
// import ProcesoNotaCreditoCompra from './componentes/compra/ProcesoNotaCreditoCompra'; // Removido temporalmente
import ProcesoFacturacion from './componentes/venta/ProcesoFacturacion';
import ProcesoNotasFactura from './componentes/venta/ProcesoNotasFactura';
import ProcesoPOS from './componentes/venta/ProcesoPOS';
import ProcesoFacturaDemo from './componentes/venta/ProcesoFacturaDemo';
import ImportarFacturasLite from './componentes/venta/ImportarFacturasLite';
import ProcesoCotizacion from './componentes/venta/ProcesoCotizacion';
import PantallaCotizaciones from './componentes/venta/PantallaCotizaciones';
import ProcesoGastoMenor from './componentes/egreso/ProcesoGastoMenor';
import ProcesoPagoExterior from './componentes/pago_exterior/ProcesoPagoExterior';
import { PantallaCxC, PerfilCliente } from './componentes/cxc';
import { PantallaCxP } from './componentes/cxp';
import ProcesoCompraUnificado from './componentes/compra/ProcesoCompraUnificado';
import AperturaCaja from './componentes/caja/AperturaCaja';
import CierreCaja from './componentes/caja/CierreCaja';
import ResumenMovimientos from './componentes/caja/ResumenMovimientos';
import HistorialCierres from './componentes/caja/HistorialCierres';
import ConfiguracionImpresionCaja from './componentes/caja/ConfiguracionImpresionCaja';
import ConfiguracionPOS from './componentes/caja/ConfiguracionPOS';
import DashboardMonitoreoCajas from './componentes/caja/DashboardMonitoreoCajas';
import AdministracionPermisos from './componentes/configuracion/AdministracionPermisos';
import MovimientosDia from './componentes/reportes/MovimientosDia';
import ReporteVentas from './componentes/reportes/ReporteVentas';
import EstadoCuentaCliente from './componentes/reportes/EstadoCuentaCliente';

// Estilos globales para todas las tablas
import './estilos/TablaEstilos.css';

const DashboardECF = lazy(() => import('./componentes/comprobante_fiscal/DashboardECF'));
const ECFOtrosEmisores = lazy(() => import('./componentes/comprobante_fiscal/ECFOtrosEmisoresPlaceholder'));

function App() {
  // const navigate = useNavigate();

  return (
    <Routes>
      <Route path='/' element={<Login />} />

      {/* Rutas protegidas dentro del layout */}
      <Route element={<Estructura />}>
        {/* Nota de Crédito Compra removida temporalmente de la UI
        <Route
          path='/ProcesoNotaCreditoCompra'
          element={
            <RutaProtegida permisoRequerido="modulo_compra">
              <ProcesoNotaCreditoCompra />
            </RutaProtegida>
          }
        />
        */}
        <Route
          path='/ProcesoGastoMenor'
          element={
            <RutaProtegida permisoRequerido="modulo_compra">
              <ProcesoGastoMenor />
            </RutaProtegida>
          }
        />
        <Route
          path='/_pagoexterior'
          element={
            <RutaProtegida permisoRequerido="modulo_permisos">
              <ProcesoPagoExterior />
            </RutaProtegida>
          }
        />
        <Route
          path='/CompraUnificada'
          element={
            <RutaProtegida permisoRequerido="modulo_compra">
              <ProcesoCompraUnificado />
            </RutaProtegida>
          }
        />
        {/* Por el momento estará deshabilitado
        <Route
          path='/ProcesoPagoExterior'
          element={
            <RutaProtegida permisoRequerido="modulo_compra">
              <ProcesoPagoExterior />
            </RutaProtegida>
          }
        />
        */}
      <Route
          path='/Dashboard'
          element={
            <RutaProtegida>
              <Dashboard />
            </RutaProtegida>
          }
        />
        <Route
          path='/DashboardECF'
          element={
            <RutaProtegida permisoRequerido="dashboard_ecf_ver">
              <Suspense fallback={<div className="p-4 text-sm text-gray-500">Cargando dashboard eCF...</div>}>
                <DashboardECF />
              </Suspense>
            </RutaProtegida>
          }
        />
        <Route
          path='/ECFOtrosEmisores'
          element={
            <RutaProtegida permisoRequerido="dashboard_ecf_ver">
              <Suspense fallback={<div className="p-4 text-sm text-gray-500">Cargando modulo eCF...</div>}>
                <ECFOtrosEmisores />
              </Suspense>
            </RutaProtegida>
          }
        />
         <Route
          path='/MantenimientoProducto'
          element={
            <RutaProtegida permisoRequerido="modulo_inventario"> {/* Aquí hay agregar el permiso requerido */}
              <MantenimientoProducto />
            </RutaProtegida>
          }
        />
         <Route
          path='/MantenimientoAlmacen'
          element={
            <RutaProtegida permisoRequerido="modulo_inventario"> {/* Aquí hay agregar el permiso requerido */}
              <MantenimientoAlmacen />
            </RutaProtegida>
          }
        />
        <Route
          path='/ProcesoTransferencia'
          element={
            <RutaProtegida permisoRequerido="modulo_inventario"> {/* Aquí hay agregar el permiso requerido */}
              <ProcesoTransferencia />
            </RutaProtegida>
          }
        />
        <Route
          path='/ProcesoAjuste'
          element={
            <RutaProtegida permisoRequerido="modulo_inventario"> {/* Aquí hay agregar el permiso requerido */}
              <ProcesoAjuste />
            </RutaProtegida>
          }
        />
        <Route
          path='/MantenimientoCategoria'
          element={
            <RutaProtegida permisoRequerido="categoria_ver">
              <MantenimientoCategoria />
            </RutaProtegida>
          }
        />
        {/* Por el momento estará deshabilitado
        <Route
          path='/MantenimientoListaPrecio'
          element={
            <RutaProtegida>
              <MantenimientoListaPrecio />
            </RutaProtegida>
          }
        />
        */}
        <Route
          path='/ProcesoCostosGastos'
          element={
            <RutaProtegida permisoRequerido="costos_gastos_ver">
              <ProcesoCostosGastos />
            </RutaProtegida>
          }
        />
        <Route
          path='/MantenimientoCuentaTesoreria'
          element={
            <RutaProtegida permisoRequerido="banco_ver_cuentas">
              <MantenimientoCuentaTributaria />
            </RutaProtegida>
          }
        />
        <Route
          path='/MantenimientoEntidad'
          element={
            <RutaProtegida permisoRequerido="modulo_entidad">
              <MantenimientoEntidad />
            </RutaProtegida>
          }
        />

        <Route
          path='/MantenimientoSecuenciasComprobante'
          element={
            <RutaProtegida permisoRequerido="modulo_configuracion">
              <MantenimientoSecuenciaComprobante />
            </RutaProtegida>
          }
        />
        <Route
          path='/ValoresPorDefecto'
          element={
            <RutaProtegida permisoRequerido="modulo_configuracion">
              <ValoresPorDefecto />
            </RutaProtegida>
          }
        />
        <Route
          path='/ConfiguracionPasarelas'
          element={
            <RutaProtegida permisoRequerido="modulo_configuracion">
              <PantallaPasarelasPago />
            </RutaProtegida>
          }
        />
        {/* <Route
          path='/ProcesoFacturacion'
          element={
            <RutaProtegida permisoRequerido="modulo_venta"> Por el momento estará deshabilitado
              <ProcesoFacturacion />
            </RutaProtegida>
          }
        /> */}
        <Route
          path='/ProcesoNotasFactura'
          element={
            <RutaProtegida permisoRequerido="modulo_venta">
              <ProcesoNotasFactura />
            </RutaProtegida>
          }
          />
        <Route
          path='/ProcesoPOS'
          element={
            <RutaProtegida permisoRequerido="modulo_venta">
              <ProcesoPOS />
            </RutaProtegida>
          }
        />
        <Route
          path='/FacturaDemo'
          element={
            <RutaProtegida permisoRequerido="modulo_venta">
              <ProcesoFacturaDemo />
            </RutaProtegida>
          }
        />
        <Route
          path='/ImportarLite'
          element={
            <RutaProtegida permisoRequerido="modulo_venta">
              <ImportarFacturasLite />
            </RutaProtegida>
          }
        />
        <Route
          path='/ProcesoCotizacion'
          element={
            <RutaProtegida permisoRequerido="modulo_cotizacion">
              <ProcesoCotizacion />
            </RutaProtegida>
          }
        />
        <Route
          path='/Cotizaciones'
          element={
            <RutaProtegida permisoRequerido="modulo_cotizacion">
              <PantallaCotizaciones />
            </RutaProtegida>
          }
        />
        <Route
          path='/Facturas'
          element={
            <RutaProtegida permisoRequerido="modulo_venta">
              <PantallaCxC />
            </RutaProtegida>
          }
        />
        {/* Backward compat alias */}
        <Route
          path='/CuentasPorCobrar'
          element={
            <RutaProtegida permisoRequerido="modulo_venta">
              <PantallaCxC />
            </RutaProtegida>
          }
        />
        {/* CxP – Cuentas por Pagar (compras) */}
        <Route
          path='/CuentasPorPagar'
          element={
            <RutaProtegida permisoRequerido="modulo_compra">
              <PantallaCxP />
            </RutaProtegida>
          }
        />
        {/* Caja */}
        <Route
          path='/AperturaCaja'
          element={
            <RutaProtegida>
              <AperturaCaja />
            </RutaProtegida>
          }
        />
        <Route
          path='/CierreCaja'
          element={
            <RutaProtegida>
              <CierreCaja />
            </RutaProtegida>
          }
        />
        <Route
          path='/ResumenMovimientos'
          element={
            <RutaProtegida>
              <ResumenMovimientos />
            </RutaProtegida>
          }
        />
        <Route
          path='/HistorialCierres'
          element={
            <RutaProtegida>
              <HistorialCierres />
            </RutaProtegida>
          }
        />
        <Route
          path='/DashboardMonitoreoCajas'
          element={
            <RutaProtegida permisoRequerido="caja_dashboard_monitoreo">
              <DashboardMonitoreoCajas />
            </RutaProtegida>
          }
        />
        <Route
          path='/ConfiguracionImpresion'
          element={
            <RutaProtegida>
              <ConfiguracionImpresionCaja />
            </RutaProtegida>
          }
        />
        <Route
          path='/ConfiguracionPOS'
          element={
            <RutaProtegida>
              <ConfiguracionPOS />
            </RutaProtegida>
          }
        />
        <Route
          path='/ReportesMovimientosDia'
          element={
            <RutaProtegida permisoRequerido="reportes_movimientos_dia">
              <MovimientosDia />
            </RutaProtegida>
          }
        />
        <Route
          path='/ReportesVentas'
          element={
            <RutaProtegida permisoRequerido="reportes_ventas">
              <ReporteVentas />
            </RutaProtegida>
          }
        />
        <Route
          path='/PerfilCliente'
          element={
            <RutaProtegida>
              <PerfilCliente />
            </RutaProtegida>
          }
        />
        <Route
          path='/ReportesEstadoCuenta'
          element={
            <RutaProtegida permisoRequerido="modulo_reportes">
              <EstadoCuentaCliente />
            </RutaProtegida>
          }
        />
        <Route
          path='/AdministracionPermisos'
          element={
            <RutaProtegida permisoRequerido="modulo_permisos">
              <AdministracionPermisos />
            </RutaProtegida>
          }
        />
      </Route>

    
      <Route path='*' element={<RutaNoEncontrada />} />
    </Routes>
  );
}

export default App;
